var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.profile)?_c('app-card',[_c('calendar',{attrs:{"events":_vm.events}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }